import { Route, Router, Switch } from 'react-router-dom';
import AppContext from './Component/Context/AppContext';
import LoadingSuspense from './Component/ShearCompo/LoadingSuspense';
import MainThemeChange from './Component/ShearCompo/MainThemeChange/MainThemeChange';
import GetRootRouting, { userList } from './Pages/RootRouting/RootRouting';
import ChildRouting from './Pages/RootRouting/ChildRouting';
import browserHistory from './Component/ShearCompo/carateBrowserHistory.js';
import sessionRoutes from './Pages/sessions/SessionRoutes';
import MainLayout from './Component/MainLayout/MainLayout';
import { ExtraDataProvider } from './Component/Context/ExtraDataContext';
import './App.scss';
import AuthGuard from './Component/Auth/AuthGuard';

const App = () => {
  const rootRouting = GetRootRouting && GetRootRouting.filter(data => {
    return data.auth && data.auth.find(p => {
      return p.includes(userList.role.find(pa => pa === p));
    })
  });

  return (
    <ExtraDataProvider>
      <AppContext.Provider value={{ rootRouting, ChildRouting }}>
        <MainThemeChange>
          <Router history={browserHistory}>
            <LoadingSuspense>
              <Switch>
                {sessionRoutes.map((item, i) => (
                  <Route
                    key={i}
                    path={item.path}
                    component={item.component}
                  />
                ))}
                <AuthGuard>
                  <MainLayout /> {" "}
                </AuthGuard>
              </Switch>
            </LoadingSuspense>
          </Router>
        </ MainThemeChange >
      </AppContext.Provider>
    </ExtraDataProvider>
  );
};

export default App;
